module.exports = __webpack_public_path__ + "img/c07_unitvillager_Normal_ua.eea0bac6.webp";